import { FeathersModel } from './feathersModel'

export class Gender extends FeathersModel {
  static serviceName = 'genders'

  gender: string
  abbr: 'F' | 'M'

  static createEmptyGender() {
    const emptyGender = new Gender()
    emptyGender.gender = ''
    emptyGender.id = null

    return emptyGender
  }

  isMale() {
    return this.abbr === 'M'
  }
  isFemale() {
    return this.abbr === 'F'
  }
}
